var _excluded = ["desc", "focusable", "title", "iconName", "className"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { string, bool } from 'prop-types';
import classNames from 'classnames';
var svg = /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.73 5.298h1.358L16 3.358l1.912 1.94h1.358L16 2zm3.404 12.397c-.595 0-.938.476-.938 1.305s.343 1.305.938 1.305c.6 0 .943-.477.943-1.305s-.343-1.305-.943-1.305zm-.116-7.476a8.78 8.78 0 108.763 8.8v-.02a8.807 8.807 0 00-8.763-8.78zm-2.224 10.653h-.654l-1.635-2.37h-.032v2.37h-.68v-3.744h.659l1.634 2.364h.032v-2.364h.676zm2.34.085A1.739 1.739 0 0114.435 19a1.718 1.718 0 113.404 0 1.74 1.74 0 01-1.705 1.957zm5.073-.085h-.83l-.842-1.503-.305.406v1.097h-.75v-3.744h.75v1.583l1.093-1.583h.815v.107l-1.147 1.53 1.216 2zm-5.184-11.87a10.01 10.01 0 11-.023 0h.023m0-1.002A11 11 0 1027 19.023v-.024A11.033 11.033 0 0016.023 8z"
}));

var Icon = function Icon(_ref) {
  var desc = _ref.desc,
      _ref$focusable = _ref.focusable,
      focusable = _ref$focusable === void 0 ? false : _ref$focusable,
      title = _ref.title,
      iconName = _ref.iconName,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: String(focusable),
    className: classNames('rds-svg--cash-insert-icon', className)
  }, rest, svg.props), title && /*#__PURE__*/React.createElement("title", null, title), desc && /*#__PURE__*/React.createElement("desc", null, desc), svg.props.children);
};

Icon.propTypes = {
  desc: string,
  focusable: bool,
  title: string,
  iconName: string,
  className: string
};
Icon.displayName = 'CashInsertIcon';
export default Icon;